query SessionAssignationData($scenarioId: ID!, $originId: ID!, $linkId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    editorView(resourceType: LINK, resourceId: $linkId) {
      sections {
        id
        code
        course {
          id
          edhCanEdit
        }
        component {
          id
          code
          name
        }
        courseComponent {
          id
          component {
            id
            code
            name
          }
        }
        sessions {
          ...AssignmentOriginalSession
        }
        unasignedSessions {
          ...AssignmentOriginalSession
        }
      }
    }
    editorWeeks(resourceType: LINK, resourceId: $linkId) {
      id
      name
      startingDate
      endingDate
      isInTerm
    }
  }
  data(scenarioId: $scenarioId) {
    allBlocks {
      id
      day
      startingTime
      endingTime
    }
  }
}

fragment AssignmentOriginalSession on Session {
  id
  blocksCount
  assignment {
    day
    days
    blocks {
      id
      day
      startingTime
      endingTime
    }
    blockRange {
      start {
        id
        day
        startingTime
        endingTime
      }
      end {
        id
        day
        startingTime
        endingTime
      }
    }
    intervals {
      id
      name
      startingDate
      endingDate
    }
  }
  classrooms {
    id
    code
    name
    classroomType {
      id
      code
      name
    }
    building {
      id
      code
      name
      campus {
        id
        code
        name
      }
    }
    floor
    usable
  }
  instructors {
    id
    code
    name
  }
}
